import Guid from "_shared/guids/guid";
import { createContext, useContext } from "react";

/**
 * A legal entity whose people a people picker leaves out altogether.
 *
 * Who bills a proposal's rate is somebody the client pays, so nobody from the client's own firm may
 * be chosen for it (#6091). The rate's picker names the client's legal entity here, and every tab
 * leaves its people out, including the marketplace's results four components below. Like
 * `RowChoiceRequiresCredentials`, the host says so once and the context carries it to every tab.
 *
 * Undefined unless a host says otherwise, so a picker nobody has thought about leaves out nobody.
 */
export const RowChoiceExcludedLegalEntity = createContext<Guid | undefined>(undefined);

export function useRowChoiceExcludedLegalEntity(): Guid | undefined {
  return useContext(RowChoiceExcludedLegalEntity);
}

/** Whether a picker that leaves out this legal entity's people leaves out this one. */
export function isInExcludedLegalEntity(
  excludedLegalEntityId: Guid | undefined,
  legalEntityId: Guid | string | null | undefined,
): boolean {
  if (!excludedLegalEntityId || !legalEntityId) return false;
  const value = typeof legalEntityId === "string" ? legalEntityId : legalEntityId.value;
  return excludedLegalEntityId.value.toLowerCase() === value.toLowerCase();
}
